import React from 'react';
import { isEmpty } from 'lodash';
import Alert from 'components/ui/Alert';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const SoftAlertHoldNotification = ({ shipment }) => {
  const { t } = useTranslation();
  const countHoldsAvailable = shipment.holds.length;
  const countResolvedHolds = shipment.holds.filter((hold) => {
    return !isEmpty(hold.resolved_at);
  }).length;

  if (countHoldsAvailable === countResolvedHolds) return null;
  return (
    (<Alert dataTestId="Alert-0330bbf1" type="warning" className="mb-2">
      <ul data-testid="ul-13ec5f81">
        <li data-testid="li-8386f9f9" key="warning">{t('SHIPMENT_ON_HOLD')}</li>
      </ul>
    </Alert>)
  );
};

SoftAlertHoldNotification.propTypes = {
  shipment: PropTypes.object.isRequired,
};

export default SoftAlertHoldNotification;
